import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare let bootstrap: any;
/* eslint-enable @typescript-eslint/no-explicit-any */

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  initializeTooltips(): void {
    const tooltips = this.document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltips.forEach((tooltip: Element) => {
      const element = tooltip as HTMLElement;
      if (!element.hasAttribute('data-bs-original-title')) {
        const tooltipInstance = new bootstrap.Tooltip(element, {
          trigger: 'click',
        });

        element.addEventListener('click', () => {
          tooltipInstance.toggle();

          setTimeout(() => {
            tooltipInstance.hide();
          }, 3000);
        });
      }
    });
  }
}
